import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AfterLoginLayoutWrapper } from "../_styles/EPL_AfterLoginLayoutWrapper_think";
import { GetCustomerDetails, GetCustomerDetailsContext, validateInputExistenece } from "../../App";
import {
  VIDEO_KYC_CREATE_PROFILE,
  VIDEO_KYC_FETCH_PROFILE,
} from "../../Config";
import { getRouteFromLoanStageService } from "../../shared/services/getRouteFromLoanStageService";
import { decrypt, encrypt } from "../../utils/crypto";
import sendRequest from "../../utils/sendRequest";
import { VideoKycExpiryModal, VideoKycMovingModal } from "../other-pages/Modals/AllModal";
import { ErrorWrapper } from "../other-pages/_styles/ErrorWrapper";
import Title from "../../components/core/Title";
import SubTitle from "../../components/core/SubTitle";
import loadingGif from "../../assets/svg/EPL_think_svg/LoadingGif.gif";
import { decryptData, encryptedData } from "../../utils";

const Vkyc = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [customerDetails, setCustomerDetails] = useContext(
    GetCustomerDetailsContext
  );
  const [isVkycModalOpen, setIsVkycModalOpen] = useState(false);
  const [toggleMessage, setToggleMessage] = useState(true);
  const [isVkycExpiryModalOpen, setIsVkycExpiryModalOpen] = useState(false);
  const [estimatedTime, setEstimatedTime] = useState("Estimated Time Required: 3 Minutes");

  useEffect(() => {
    if (
      validateInputExistenece(customerDetails) &&
      validateInputExistenece(customerDetails["stage"])
    ) {
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: customerDetails.stage,
      });
      navigate(`${route}`, {
        replace: true,
        state: {
          customerDetails: customerDetails,
        },
      });
    }
  }, [customerDetails]);

  useEffect(() => {
    let timer;

    const getCustomerDetails = async () => {
      await GetCustomerDetails(
        sessionStorage.getItem("application_form_no"),
        location.pathname.split("/")[1],
        customerDetails,
        setCustomerDetails,
        navigate
      );
      if (customerDetails?.stage === "VKYC_IN_PROGRESS") {
        checkVideoKycStatus();
      }
    };

    if (customerDetails?.stage === "VKYC_START") {
      setIsVkycModalOpen(true);
    } else if (customerDetails?.stage === "VKYC_IN_PROGRESS") {
      timer = setTimeout(() => {
        setToggleMessage(!toggleMessage);
        getCustomerDetails();
      }, 30000); // 30 sec in milliseconds
    }

    return () => {
      clearTimeout(timer); // Clear the timer if the component unmounts or if customerDetails changes
    };
  }, []);

  const startVideoKyc = async () => {
    try {
      const response = await fetchKycLink();
      const decryptedData = await decryptData(response.data);
      if (decryptedData?.STAGE == "OKYC_START"){
        setCustomerDetails({
          ...customerDetails,
          stage: decryptedData?.STAGE,
        });
      }
      const captureLink = decryptedData?.Data?.captureLink;
      if (captureLink) {
        window.open(captureLink, "_self");
        setIsVkycModalOpen(false);
        setCustomerDetails({
          ...customerDetails,
          stage: response.response.STAGE,
        });
      } else {
        throw new Error("No capture link received.");
      }
    } catch (error) {
      if (error === "Unauthorised") {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "",
        });
        navigate(`${route}`, {
          replace: true,
        });
      } else {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
        navigate(`${route}`, {
          replace: true,
        });
      }
    }
  };

  const fetchKycLink = async () => {
    try {
      const formData = new FormData();
      const requestData = {
        application_form_number: customerDetails?.application_form_number,
        current_stage: customerDetails?.stage,
      };
      formData.append("data", encryptedData(requestData));
      return await sendRequest(
        `/${customerDetails.source}${VIDEO_KYC_CREATE_PROFILE}`,
        formData
      );
    } catch (error) {
      if (error === "Unauthorised") {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "",
        });
        navigate(`${route}`, {
          replace: true,
        });
      } else {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
        navigate(`${route}`, {
          replace: true,
        });
      }
    }
  };

  const checkVideoKycStatus = async () => {
    try {
      const formData = new FormData();
      const requestData = {
        application_form_no: customerDetails?.application_form_number,
      };
      formData.append("data", encryptedData(requestData));
      const response = await sendRequest(
        `/${customerDetails.source}${VIDEO_KYC_FETCH_PROFILE}`,
        formData
      );
      if (response.status === 200) {
        if (response?.response?.Data?.status === "expired") {
          setIsVkycExpiryModalOpen(true);
        }
        if (
          response?.response?.Data?.status === "approved" ||
          response?.response?.Data?.status === "rejected"
        ) {
          setCustomerDetails({
            ...customerDetails,
            stage: response?.response?.STAGE,
          });
        }
        if (response?.response?.Data?.status === "pending") {
          if (response?.response?.capture_url) {
            window.open(response?.response?.capture_url, "_self");
          } else {
            throw new Error("No capture link received.");
          }
        }
        setEstimatedTime("Estimated Time Required: 1 Hour")
      }
    } catch (error) {
      if (error === "Unauthorised") {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "",
        });
        navigate(`${route}`, {
          replace: true,
        });
      } else {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
        navigate(`${route}`, {
          replace: true,
        });
      }
    }
  };

  return (
    <AfterLoginLayoutWrapper>
      {/* Render different content when VKYC_IN_PROGRESS */}
      {customerDetails?.stage === "VKYC_IN_PROGRESS" && (
        <ErrorWrapper className="first-child">
          <Title
            id="pageTitle"
            className="pageTitle"
            text={"Please Wait"}
            visible={true}
            clickable={false}
            style={{
              fontSize: "24px",
            }}
          />
          <div
            style={{
              marginTop: "20px",
              textAlign: "center",
            }}
          >
            <SubTitle
              id="pageSubTitle"
              className="pageSubTitle loading"
              text={
                toggleMessage
                  ? "We are checking VKYC status internally"
                  : "Hold on!, We are almost done"
              }
              style={{
                fontSize: "20px",
              }}
            />
          </div>
          <div className="image">
            <img
              height={200}
              width={200}
              src={loadingGif}
              alt="Loading"
            />
          </div>
          <div
            style={{
              marginTop: "20px",
              textAlign: "center",
            }}
          >
            <SubTitle
              id="pageSubTitle"
              className="pageSubTitle"
              text={estimatedTime}
              style={{
                fontSize: "20px",
                fontWeight: "700",
              }}
            />
          </div>
        </ErrorWrapper>
      )}
      {/* Render VKYC modal when needed */}
      <VideoKycMovingModal
        isOpen={isVkycModalOpen}
        onModalSubmit={startVideoKyc}
        onClose={() => { }}
      />
      <VideoKycExpiryModal
        isOpen={isVkycExpiryModalOpen}
        onModalSubmit={() => {
          setCustomerDetails({
            ...customerDetails,
            stage: "OKYC_START",
          });
        }}
        onClose={() => { }}
      />
    </AfterLoginLayoutWrapper>
  );
};

export default Vkyc;